import AxiosInstance from "./api";

export const OutsourcingPaymentTableService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/outsourcing-payment-table", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/outsourcing-payment-table/" + id);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/outsourcing-payment-table", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/outsourcing-payment-table/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/outsourcing-payment-table/" + id);
  },
};
